import React, { Component } from 'react';
import { get, isNull, has } from "lodash"
import { withStepsState } from "./../../../shared/containers/containerStepsState"
import RadioCheckButtonfirstQuestionB from '../../../shared/items/controls/radioCheckButtonfirstQuestionB';
import { isCurrentStep, buildStepClassName, updateOpenStepState } from "./../../../shared/services/service.step"
import locales from "./../../../content.json"
import "./../../../shared/services/service.step.scss"
import { steps } from "../../../shared/static.steps"
import styles from './firstPageQuestionB.module.scss'

import img1 from "./img/i1.png"
import img2 from "./img/i2.png"
import img3 from "./img/i3.png"
import img4 from "./img/i4.png"

const resultFemale = {
  lose: {
      value: "Lose weight",
      title: locales[window.userLang].lose_weight,
      img: img1
  },
  tone: {
      value: "Body tone up",
      title: locales[window.userLang].tone_up,
      img: img2
  },
  love: {
      value: "Love myself",
      title: locales[window.userLang].love_myself,
      img: img3
  },
  muscle: {
      value: "Gain Muscles",
      title: locales[window.userLang].gain_muscles,
      img: img4
  },
}

class FirstPageQuestionB extends Component {
  constructor() {
    super();

    this.state = {
      isOpenFirstPageQuestionB: false,
      itemsData: resultFemale
    }
  }

  componentDidMount() {
    if (isCurrentStep(this.props.currentIndex, steps.firstPageQuestionB) && !this.state.isOpenFirstPageQuestionB)
      this.setState({ isOpenFirstPageQuestionB: true })
  }

  componentDidUpdate(prevProps) {
    const { currentIndex, onSetStepData, data } = this.props
    const { isOpenFirstPageQuestionB } = this.state
    const params = {
      currentIndex: currentIndex,
      prevIndex: prevProps.currentIndex,
      stepIndex: steps.firstPageQuestionB,
      isOpen: isOpenFirstPageQuestionB,
      handleChange: this.handleChangeOpen.bind(this),
    }

    if (isOpenFirstPageQuestionB && !has(data, ["firstPageQuestionB"]))
      onSetStepData("firstPageQuestionB")

    updateOpenStepState({ params })
  }

  handleChangeOpen(state) {
    const nextState = state === true
      ? {
        isOpenFirstPageQuestionB: state,
      }
      : {
        isOpenFirstPageQuestionB: state,
      }

    this.setState(nextState)
  }
    
  render() {
    const { currentIndex, data, onUpdateStepData } = this.props
    const { isOpenFirstPageQuestionB, itemsData } = this.state
    const params = {
      className: "firstPageQuestionB",
      currentIndex: currentIndex,
      stepIndex: steps.firstPageQuestionB,
    }

    return isOpenFirstPageQuestionB ?
      <div className={buildStepClassName({ params })} style={{ padding: "0" }}>

        <div className={styles.firstPageQuestionB_wrapper}>
          
          <div className={styles.firstPageQuestionB_description}>
            {locales[window.userLang].firstPageQuestion_description}
          </div>

          <div className={styles.firstPageQuestionB_title}>
          {locales[window.userLang].goal_ask}
          </div>

          <div className={styles.firstPageQuestionB_buttonsWrapper}>
          {
            Object.keys(itemsData).map((key, index) => {
              return (
                <RadioCheckButtonfirstQuestionB
                  isChecked={get(data, ["result", "value"], null) === itemsData[key].value}
                  key={index}
                  onClick={() => {
                    if (get(data, ["result", "value"], null) !== itemsData[key].value) {
                      onUpdateStepData.bind(this, "sex", "value", "female")();
                      onUpdateStepData.bind(this, "result", "value", itemsData[key].value)();
                      onUpdateStepData.bind(this, "result", "title", itemsData[key].title)();
                      setTimeout(this.props.onToNextStep , 300);

                      window.dataLayer = window.dataLayer || [];
                      window.dataLayer.push({
                        'event':'step1-completed',
                        'onb_answer_varB': itemsData[key].title
                      });

                    }
                  }}
                  icon={false}
                  image={itemsData[key].img}
                  title={itemsData[key].title}
                >
                </RadioCheckButtonfirstQuestionB>
              )
            })
          }
          </div>
          </div>
        </div>
      : null
  }
}

export default withStepsState(FirstPageQuestionB);